import React, { useState, useEffect } from 'react';
import { Button } from '@upsales/components';
import { useTranslation } from 'Components/Helpers/translate';
import Client from 'App/resources/Model/Client';
import openModal from 'App/services/Modal';
import { useContactScraperAccess } from './useContactScraperAccess';

interface ContactScraperProps {
	client: Client;
}

const ContactScraper = ({ client }: ContactScraperProps) => {
	const { t } = useTranslation();
	const [isDisabled, setIsDisabled] = useState(!client.webpage);
	const { hasAccess } = useContactScraperAccess();

	useEffect(() => {
		setIsDisabled(!client.webpage);
	}, [client.webpage]);

	// Don't render the button if user doesn't have role-based access
	if (!hasAccess) {
		return null;
	}

	const openConfirmModal = () => {
		openModal('ContactScraperConfirmModal', {
			client,
			onClose: (success?: boolean) => {
				if (success) {
					setIsDisabled(true);
				}
			}
		});
	};

	return (
		<Button
			shadow="none"
			color="super-light-green"
			icon="stars"
			onClick={openConfirmModal}
			id="contact-scraper-button"
			disabled={isDisabled}
		>
			{t('client.startScrape')}
		</Button>
	);
};

export default ContactScraper;
